const ERRORS_CONFIG = type =>
  ({
    login: {
      username: "",
      password: "",
      non_field_errors: ""
    },
    password: {
      current_password: "",
      new_password: ""
    }
  }[type]);

export default ERRORS_CONFIG;
